export enum USER_ROLE {
  FULL = 'full',
  DATA = 'data',
  DOCUMENTATION = 'documentation',
}
